import { injectGlobal } from 'styled-components';
import normalize from 'normalize.css';
import IRANSansWebFaNumMediumEot from './assets/fonts/iranSans/eot/IRANSansWeb(FaNum)_Medium.eot';
import IRANSansWebFaNumMediumWoff2 from './assets/fonts/iranSans/woff2/IRANSansWeb(FaNum)_Medium.woff2';
import IRANSansWebFaNumMediumWoff from './assets/fonts/iranSans/woff/IRANSansWeb(FaNum)_Medium.woff';
import IRANSansWebFaNumMediumTtf from './assets/fonts/iranSans/ttf/IRANSansWeb(FaNum)_Medium.ttf';
import IRANSansWebFaNumEot from './assets/fonts/iranSans/eot/IRANSansWeb(FaNum).eot';
import IRANSansWebFaNumWoff2 from './assets/fonts/iranSans/woff2/IRANSansWeb(FaNum).woff2';
import IRANSansWebFaNumWoff from './assets/fonts/iranSans/woff/IRANSansWeb(FaNum).woff';
import IRANSansWebFaNumTtf from './assets/fonts/iranSans/ttf/IRANSansWeb(FaNum).ttf';
import IRANSansWebFaNumUltraLightEot from './assets/fonts/iranSans/eot/IRANSansWeb(FaNum)_UltraLight.eot';
import IRANSansWebFaNumUltraLightWoff2 from './assets/fonts/iranSans/woff2/IRANSansWeb(FaNum)_UltraLight.woff2';
import IRANSansWebFaNumUltraLightWoff from './assets/fonts/iranSans/woff/IRANSansWeb(FaNum)_UltraLight.woff';
import IRANSansWebFaNumUltraLightTtf from './assets/fonts/iranSans/ttf/IRANSansWeb(FaNum)_UltraLight.ttf';
import OpenSansMedium from './assets/fonts/openSans/OpenSans-Regular.woff';
import OpenSansBold from './assets/fonts/openSans/OpenSans-Bold.woff';
import OpenSansLight from './assets/fonts/openSans/OpenSans-Light.woff';

// eslint-disable-next-line no-unused-expressions
injectGlobal`
  ${normalize}
  @font-face {
    font-family: IRANSans;
    font-style: normal;
    font-weight: bold;
    src: url('${IRANSansWebFaNumMediumEot}');
    src: url('${IRANSansWebFaNumMediumEot}?#iefix') format('embedded-opentype'), /* IE6-8 */ url('${IRANSansWebFaNumMediumWoff2}') format('woff2'), /* FF39+,Chrome36+, Opera24+*/ url('${IRANSansWebFaNumMediumWoff}') format('woff'), /* FF3.6+, IE9, Chrome6+, Saf5.1+*/ url('${IRANSansWebFaNumMediumTtf}') format('truetype');
  }
  @font-face {
    font-family: IRANSans;
    font-style: normal;
    font-weight: normal;
    src: url('${IRANSansWebFaNumEot}');
    src: url('${IRANSansWebFaNumEot}?#iefix') format('embedded-opentype'), /* IE6-8 */ url('${IRANSansWebFaNumWoff2}') format('woff2'), /* FF39+,Chrome36+, Opera24+*/ url('${IRANSansWebFaNumWoff}') format('woff'), /* FF3.6+, IE9, Chrome6+, Saf5.1+*/ url('${IRANSansWebFaNumTtf}') format('truetype');
  }
  @font-face {
    font-family: IRANSans;
    font-style: normal;
    font-weight: 200;
    src: url('${IRANSansWebFaNumUltraLightEot}');
    src: url('${IRANSansWebFaNumUltraLightEot}?#iefix') format('embedded-opentype'), /* IE6-8 */ url('${IRANSansWebFaNumUltraLightWoff2}') format('woff2'), /* FF39+,Chrome36+, Opera24+*/ url('${IRANSansWebFaNumUltraLightWoff}') format('woff'), /* FF3.6+, IE9, Chrome6+, Saf5.1+*/ url('${IRANSansWebFaNumUltraLightTtf}') format('truetype');
  }
  
  @font-face {
    font-family: 'OpenSans';
    font-style: normal;
    font-weight: bold;
    src: local('OpenSans'), url('${OpenSansBold}') format('woff');
  }
  @font-face {
    font-family: OpenSans;
    font-style: normal;
    font-weight: normal;
    src: local('OpenSans'), url('${OpenSansMedium}') format('woff');
  }
  @font-face {
    font-family: OpenSans;
    font-style: normal;
    font-weight: 200;
    src: local('OpenSans'), url('${OpenSansLight}') format('woff');
  }
  
  html, body {
    padding: 0;
    margin: 0;
    height: 100%;
    background: #151515;
    overflow: hidden;
  }
  
  html {
    font-size: 1.8vh;
  }

  body {
    line-height: 2.4rem;
    user-select: none;
    cursor: default;
    direction: rtl;
    text-align: right;
    font-family: "IRANSans", sans-serif, Serif;
    font-weight: normal;
    &.ltr {
      direction: ltr;
      text-align: left;
      font-family: "OpenSans", sans-serif, Serif;
    }
  }
  
  a {
    text-decoration: none;
  }
  
  body > #app {
    position: absolute;
    margin: auto;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    overflow: hidden;
  }
`;
